// Do not add vue content nor http requests in this file as it is used in ckeditor model plugin
export enum IContentModel {
  Post = 'post',
  Idea = 'idea',
  Question = 'iquestion',
  Media = 'media',
  Conference = 'conference',
  Survey = 'survey',
  Wedo = 'wedo',
  Wiki = 'wiki',
  WikiTree = 'wikitree', // Q61: should not be here
  // Derived = 'derived', // Q61: should not be here
  DerivedPost = 'derivedpost', // TODO: Check if we can place this somewhere else. Placed here as union of enums is causing problems in context (spreading enums there)
  DerivedIdea = 'derivedidea',
  Rituals = 'conferencetemplate',
  Streaming = 'meetingstreaming', // this a front-end pseudo-type before creation we switch to conference type
  FacetExperience = 'facetExperience',
}
